import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background grain px-6">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md rounded-3xl border border-border bg-card p-10">
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <span className="grid place-items-center w-10 h-10 rounded-full bg-primary text-primary-foreground"><Sprout size={20} /></span>
          <span className="font-serif-display text-xl">Kalpavriksha</span>
        </Link>
        <h1 className="font-serif-display text-3xl">Admin Login</h1>
        <p className="text-muted-foreground text-sm mt-2 mb-8">Manage blog, projects, services, pricing, and leads.</p>
        <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full rounded-xl border border-border bg-transparent px-4 py-3 text-sm outline-none focus:border-accent transition-colors mb-4" />
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full rounded-xl border border-border bg-transparent px-4 py-3 text-sm outline-none focus:border-accent transition-colors mb-6" />
        <button data-testid="admin-login-submit" disabled={loading} className="w-full rounded-full bg-primary text-primary-foreground py-3.5 font-medium hover:bg-accent hover:text-accent-foreground transition-colors disabled:opacity-50">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
